// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"1511d218","320":"c1af878b","823":"85970bf5","963":"d719b153"}[chunkId] + ".chunk.js";
};